import type { AppDispatch, RootState } from '_store';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import { useBarcodeScanner } from './useBarcodeScanner';
import { useIsMobile } from './useIsMobile';

export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

export { useBarcodeScanner, useIsMobile };
